class Revision {
    constructor(data, store){
        this.data = data;
        this.store = store;
    }
}
export { Revision };
